<template>
  <div class="order">
    <van-nav-bar title="密码修改" left-arrow @click-left="$router.go(-1)" />
   <van-field
    v-model="password_old"
    type="password"
    name="原密码"
    label="原密码"
    placeholder="原密码"
    :rules="[{ required: true, message: '请填写原密码' }]"
  />
  <van-field
    v-model="password_new"
    type="password"
    name="新密码"
    label="新密码"
    placeholder="新密码"
    :rules="[{ required: true, message: '请填写新密码' }]"
  />
  <van-field
    v-model="password_confirm"
    type="password"
    name="新密码确认"
    label="新密码确认"
    placeholder="再次输入新密码"
    :rules="[{ required: true, message: '请再次输入新密码' }]"
  />
    <van-button type="primary" class="search-btn" block  @click="submit">确认修改</van-button>

    
  </div>
</template>

<script>

import { changePassword } from '@/api/home'

import { getInfo } from '@/utils/storage'

export default {
  name: 'AccessRecord',
  components: {
    
  },
  data () {
    return {
      password_old: '',
      password_new: '',
      password_confirm: '',



    }
  },
  mounted () {
    
  },
  methods: {
    
    submit() {
      if (!this.password_old) {
        this.$toast('请输入原密码')
        return
      }
      if (!this.password_new) {
        this.$toast('请输入新密码')
        return
      }
      if (!this.password_confirm) {
        this.$toast('请输入新密码确认')
        return
      }
      if (this.password_new !== this.password_confirm) {
        this.$toast('新密码两次输入不一致')
        return
      }

      const userInfo = getInfo()
      let params = {
        password_new: this.password_new,
        password_old: this.password_old,
        uid: userInfo.userId

      }
      changePassword(params).then(res => {
        
        if(res.code==10000){
           this.$toast('修改成功')

           this.$store.dispatch('user/logout')
           this.$router.push('/login')
        }else{
          this.$toast(res.message)
        }


        

      })

    }

  },
  watch: {
    
  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}
.van-tabs {
  position: sticky;
  top: 0;
}
.search-btn{
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}
.access_box{
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
